import DomainAdd from '../components/DomainAdd.vue';
import DomainListBatchJobs from '../components/DomainListBatchJobs.vue';
import DomainCrawlSummary from '../components/DomainCrawlSummary.vue';
import AddWebpagesToSubscribedDomain from '../components/AddWebpagesToSubscribedDomain.vue';
import DomainList from '../components/DomainList.vue';
import DomainCrawlResultManagement from "@modules/Domain/components/DomainCrawlResultManagement";
import DomainIgnoredUrls from "@modules/Domain/components/DomainIgnoredUrls";
import DomainWebpageList from "@modules/Domain/components/DomainWebpageList";
import DomainCrawlScheduleList from "@modules/Domain/components/DomainCrawlScheduleList";
import DomainCrawlScheduleAdd from "@modules/Domain/components/DomainCrawlScheduleAdd";
import DomainCrawlScheduleEdit from "@modules/Domain/components/DomainCrawlScheduleEdit";
import DomainWebpageAdd from "@modules/Domain/components/DomainWebpageAdd";
import WebpageEdit from "@modules/Webpages/components/WebpageEdit";
import ResponsePerformance from "@modules/Webpages/components/ResponsePerformance";

export default [
  {
    path: '',
    redirect: 'add',
    role: ['User']
  },
  {
    path: '/domain/add',
    component: DomainAdd,
    meta: {
      title: 'Add Domain',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain',
          title: 'Domains'
        },
        {
          path: '/domain/add',
          title: 'Add Domain'
        }
      ]
    }
  },
  {
    path: '/domain/add-webpage',
    component: DomainWebpageAdd,
    meta: {
      title: 'Add Webpages',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain/list',
          title: 'Domains'
        },
        {
          path: '/domain/add-webpage',
          title: 'Add Webpages'
        }
      ]
    }
  },
  {
    path: '/domain/:id/add-webpage',
    component: DomainWebpageAdd,
    meta: {
      title: 'Add Webpages',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain/list',
          title: 'Domains'
        },
        {
          path: '/domain/:id/add-webpage',
          title: 'Add Webpages'
        }
      ]
    }
  },
  {
    path: '/domain/list-batch-job',
    component: DomainListBatchJobs,
    meta: {
      title: 'List of Batch Jobs',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain/list',
          title: 'Domains'
        },
        {
          path: '/domain/list-batch-job',
          title: 'List of Batch Jobs'
        }
      ]
    }
  },
  {
    path: '/domain/list',
    component: DomainList,
    meta: {
      title: 'View Domains',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain',
          title: 'Domains'
        },
        {
          path: '/domain/list',
          title: 'View Domains'
        }
      ]
    }
  },
  {
    path: '/domain/:id/crawl-summary',
    component: DomainCrawlSummary,
    meta: {
      title: 'Crawl Summary',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain/list',
          title: 'Domains'
        },
        {
          path: '/domain/:id/crawl-summary',
          title: 'Crawl Summary'
        }
      ]
    },
  },
  {
    path: '/domain/:id/crawl-result-management',
    component: DomainCrawlResultManagement,
    meta: {
      title: 'Crawl Result Management',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain/list',
          title: 'Domains'
        },
        {
          path: '/domain/:id/crawl-result-management',
          title: 'Crawl Result Management'
        }
      ]
    }
  },
  {
    path: '/domain/:id/ignored-webpages',
    component: DomainIgnoredUrls,
    meta: {
      title: 'List of Ignored URLs',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain/list',
          title: 'Domains'
        },
        {
          path: '/domain/:id/ignored-webpages',
          title: 'List of Ignored URLs'
        }
      ]
    }
  },
  {
    path: '/domain/:id/webpages',
    component: DomainWebpageList,
    meta: {
      title: 'List of Webpages',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain/list',
          title: 'Domains'
        },
        {
          path: '/domain/:id/webpages',
          title: 'List of Webpages'
        }
      ]
    }
  },
  {
    path: '/domain/:domainId(\\d+)/webpages/:id',
    component: WebpageEdit,
    meta: {
      title: 'Edit Webpage',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain/list',
          title: 'Domains'
        },
        {
          path: '/domain/:domainId/webpages', // we still specify a path to not break existing logic
          dynamicPath: route => `/domain/${route.params.domainId}/webpages`,
          title: 'List of Webpages'
        },
        {
          path: '',
          title: 'Edit Webpage Configuration'
        }
      ]
    }
  },
  {
    path: '/domain/:domainId(\\d+)/webpages/:id/response-performance',
    component: ResponsePerformance,
    meta: {
      title: 'Response Performance',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain/list',
          title: 'Domains'
        },
        {
          path: '/domain/:domainId/webpages', // we still specify a path to not break existing logic
          dynamicPath: route => `/domain/${route.params.domainId}/webpages`,
          title: 'List of Webpages'
        },
        {
          path: '',
          title: 'Response Performance'
        }
      ]
    }
  },
  {
    path: '/domain/list-crawl-schedule',
    component: DomainCrawlScheduleList,
    meta: {
      title: 'List Crawl Schedules',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain/list',
          title: 'Domains'
        },
        {
          path: '/domain/list-crawl-schedule',
          title: 'List Crawl Schedules'
        }
      ]
    }
  },
  {
    path: '/domain/add-crawl-schedule',
    component: DomainCrawlScheduleAdd,
    meta: {
      title: 'Add Crawl Schedule',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain/list',
          title: 'Domains'
        },
        {
          path: '/domain/list-crawl-schedule',
          title: 'Crawl Schedules'
        },
        {
          path: '/domain/add-crawl-schedule',
          title: 'Add Crawl Schedule'
        }
      ]
    }
  },
  {
    path: '/domain/edit-crawl-schedule/:id',
    component: DomainCrawlScheduleEdit,
    meta: {
      title: 'Edit Crawl Schedule',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain/list',
          title: 'Domains'
        },
        {
          path: '/domain/list-crawl-schedule',
          title: 'Crawl Schedules'
        },
        {
          path: '/domain/edit-crawl-schedule',
          title: 'Edit Crawl Schedule'
        }
      ]
    }
  },
];
